const Heart = () => (
	<svg
		width="16"
		height="14"
		viewBox="0 0 16 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="heart-default"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.7989 2.20109C12.1975 0.599638 9.60124 0.599638 8 2.20109C6.39855 0.599638 3.80233 0.599638 2.20109 2.20109C0.599638 3.80253 0.599638 6.89876 2.20109 8.50021C4.13406 10.6411 6.06703 12.0449 8 12.7116C9.93297 12.0449 11.8659 10.6411 13.7989 8.50021C15.4004 6.89876 15.4004 3.80253 13.7989 2.20109Z"
			stroke="#7360F2"
			strokeWidth="1.5"
		/>
	</svg>
);

export const HeartFilled = () => (
	<svg
		width="16"
		height="14"
		viewBox="0 0 16 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="heart-filled"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.7989 2.20109C12.1975 0.599638 9.60124 0.599638 8 2.20109C6.39855 0.599638 3.80233 0.599638 2.20109 2.20109C0.599638 3.80253 0.599638 6.89876 2.20109 8.50021C4.13406 10.6411 6.06703 12.0449 8 12.7116C9.93297 12.0449 11.8659 10.6411 13.7989 8.50021C15.4004 6.89876 15.4004 3.80253 13.7989 2.20109Z"
			stroke="#7360F2"
			fill="#7360F2"
			strokeWidth="1.5"
		/>
	</svg>
);

export default Heart;
